export type ProgressBarDataType = {
  value: number;
  color: string;
  label: string;
  id: string;
};

export type BranchRevenueResponse = {
  branch_id: string;
  branch_name: string;
  branch_revenue: {
    date: string;
    collected: number;
    due: number;
  }[];
};

export type DateRangeType = {
  startDate: string;
  endDate: string;
};

export type GroupPerfomanceType = {
  amount_collected: string;
  amount_due: string;
  branch_name: string;
  branch_id: string;
  group_name: string;
  group_id: string;
};

export type PaymentDateFilterType = 'due_at' | 'paid_at';

export enum PaymentDateFilterTypeEnum {
  DUE_AT = 'due_at',
  PAID_AT = 'paid_at'
}

export type OnlinePaymentBreakdown = {
  upi: string;
  upi_credit_card: string;
  cards: string;
  net_banking: string;
  mandates: string;
  others: string;
};

export type OfflinePaymentBreakdown = {
  upi: string;
  bank: string;
  cash: string;
  cheque: string;
};

export type DailyPaymentVolume = {
  day: string;
  online_payment_breakdown?: OnlinePaymentBreakdown;
  offline_payment_breakdown?: OfflinePaymentBreakdown;
};

export type SettlementAccount = {
  bank_account_name: string;
  bank_name: string;
  bank_nick_name: string;
  bank_account_number: string;
  amount_settled: string;
};

export type DailySettlement = {
  day: string;
  accounts: SettlementAccount[];
};

export type DailyListResponse<T> = { data: T[] };

export type DashboardQueryRequest = {
  organizationId: string;
  queryString: string;
};

export enum DailyReportType {
  COLLECTION = 'collection',
  SETTLEMENT = 'settlement'
}

export type DailyReportJobRequest = DashboardQueryRequest & {
  reportType: DailyReportType;
};
